import { render, staticRenderFns } from "./ChatGroupRtcBanner.vue?vue&type=template&id=069a7259&scoped=true"
import script from "./ChatGroupRtcBanner.vue?vue&type=script&lang=js"
export * from "./ChatGroupRtcBanner.vue?vue&type=script&lang=js"
import style0 from "./ChatGroupRtcBanner.vue?vue&type=style&index=0&id=069a7259&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../lianqiao-im/im-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "069a7259",
  null
  
)

export default component.exports